import { useQuery } from 'react-query'

import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { Card } from '@webapp/modules/spending-cards/entities/Card'
import { SpendingCardKeys } from '@webapp/modules/spending-cards/entities/enums/SpendingCardKeysEnum'

type UseQueryMyPhysicalCardReturn = {
  card: Nullable<Card>
  isLoading: boolean
  isFetching: boolean
  isFetched: boolean
}

export const useQueryMyPhysicalCard = ({
  enabled = false,
  onError,
}: {
  enabled: boolean
  onError?: (error: Error) => void
}): UseQueryMyPhysicalCardReturn => {
  const { data, isLoading, isFetched, isFetching } = useQuery({
    queryKey: [...SpendingCardKeys.GET_MY_PHYSICAL_CARD],
    queryFn: () => cardRepository.getMyPhysicalCard(),
    enabled,
    onError,
  })

  return {
    card: data?.data ? new Card(data.data) : null,
    isLoading,
    isFetching,
    isFetched,
  }
}
